/* ============================================================
 * VAELON — accurate colour swatches (hybrid sampler + manual overrides)
 *
 * Swatch dots match the real product photos, replacing the coarse
 * name->hex map (snippets/color-hex.liquid).
 *
 * Priority per swatch:
 *   0. MANUAL OVERRIDE — typed in the theme editor
 *      (Product page > Colour swatch overrides). Two formats:
 *        Solid:     Colour Name: #hex
 *        Two-tone:  Colour Name: #hexLeft / #hexRight   (rebuilds the split)
 *      Overrides win over everything and apply to solid OR gradient dots.
 *   1. PHOTO SAMPLE — solid dots only: load variant image CORS-safe at
 *      ?width=80, sample centre box, drop near-white bg + skin pixels,
 *      take MEDIAN R/G/B (median beats mean on stripes).
 *   2. CONFIDENCE GUARD — too few fabric pixels => keep original hex.
 *   3. HUE-FAMILY GUARD — sample outside the name's hue family => keep hex.
 *
 * Un-overridden two-tone (gradient) dots keep their Liquid gradient. PDP-only.
 * ============================================================ */
(function () {
  'use strict';
  var variants = window.__variants;
  if (!variants || !variants.length) return;
  var swatches = document.querySelectorAll('.swatches .sw');
  if (!swatches.length) return;

  function normHex(h) {
    if (!h) return null;
    h = h.trim();
    if (h.charAt(0) !== '#') h = '#' + h;
    return /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(h) ? h : null;
  }

  /* ---- parse manual overrides ----
   * 'Name: #hex'              -> { type:'solid', a:'#hex' }
   * 'Name: #hexA / #hexB'     -> { type:'duo',   a:'#hexA', b:'#hexB' }
   */
  var overrides = {};
  (function () {
    var raw = window.__swatchOverrides;
    if (!raw || typeof raw !== 'string') return;
    raw.split(/\r?\n/).forEach(function (line) {
      var i = line.indexOf(':');
      if (i === -1) return;
      var name = line.slice(0, i).trim().toLowerCase();
      if (!name) return;
      var rhs = line.slice(i + 1);
      var parts = rhs.split('/');
      if (parts.length >= 2) {
        var a = normHex(parts[0]), b = normHex(parts[1]);
        if (a && b) { overrides[name] = { type: 'duo', a: a, b: b }; return; }
        // if only one side is valid, fall through to solid using whichever parsed
        var one = a || b;
        if (one) { overrides[name] = { type: 'solid', a: one }; return; }
      } else {
        var h = normHex(rhs);
        if (h) overrides[name] = { type: 'solid', a: h };
      }
    });
  })();

  function imgForColor(val) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i], o = v.options || [];
      if (o.indexOf(val) !== -1 && v.featured_image && v.featured_image.src) return v.featured_image.src;
    }
    return null;
  }
  function toUrl(raw) {
    var u = (raw.charAt(0) === '/' && raw.charAt(1) === '/') ? 'https:' + raw : raw;
    return u.split('?')[0] + '?width=80';
  }
  function median(a) {
    a.sort(function (x, y) { return x - y; });
    var m = a.length >> 1;
    return a.length % 2 ? a[m] : Math.round((a[m - 1] + a[m]) / 2);
  }
  function isSkin(r, g, b) {
    return r > 95 && g > 40 && b > 20 && r > g && g > b && (r - b) > 15 && (r - b) < 120 && (r - g) < 80;
  }
  function hueSat(r, g, b) {
    r /= 255; g /= 255; b /= 255;
    var mx = Math.max(r, g, b), mn = Math.min(r, g, b), d = mx - mn, h = 0;
    if (d !== 0) {
      if (mx === r) h = ((g - b) / d) % 6;
      else if (mx === g) h = (b - r) / d + 2;
      else h = (r - g) / d + 4;
      h *= 60; if (h < 0) h += 360;
    }
    var l = (mx + mn) / 2;
    var s = d === 0 ? 0 : d / (1 - Math.abs(2 * l - 1));
    return [h, s];
  }
  var FAMILIES = [
    { kw: ['lilac', 'lavender', 'purple', 'violet', 'grape', 'taro'], min: 250, max: 320 },
    { kw: ['pink', 'rose', 'blush', 'mauve'], min: 300, max: 360 },
    { kw: ['red', 'ruby', 'crimson', 'scarlet', 'wine', 'cherry'], min: 0, max: 20 },
    { kw: ['orange', 'clay', 'terracotta', 'rust'], min: 18, max: 45 },
    { kw: ['yellow', 'gold', 'dandelion', 'mustard', 'butter'], min: 40, max: 70 },
    { kw: ['green', 'olive', 'sage', 'mint', 'honeydew'], min: 70, max: 165 },
    { kw: ['blue', 'navy', 'azure', 'cobalt', 'sky', 'teal'], min: 175, max: 250 }
  ];
  function expectedFamily(name) {
    var n = (name || '').toLowerCase();
    for (var i = 0; i < FAMILIES.length; i++)
      for (var j = 0; j < FAMILIES[i].kw.length; j++)
        if (n.indexOf(FAMILIES[i].kw[j]) !== -1) return FAMILIES[i];
    return null;
  }
  function inFamily(h, fam) {
    if (fam.min <= fam.max) return h >= fam.min && h <= fam.max;
    return h >= fam.min || h <= fam.max;
  }
  function load(u) {
    return new Promise(function (res) {
      var img = new Image();
      img.crossOrigin = 'anonymous';
      var t = setTimeout(function () { res(null); }, 8000);
      img.onload = function () { clearTimeout(t); res(img); };
      img.onerror = function () { clearTimeout(t); res(null); };
      img.src = u;
    });
  }
  function sample(img) {
    try {
      var c = document.createElement('canvas');
      c.width = img.naturalWidth; c.height = img.naturalHeight;
      if (!c.width || !c.height) return null;
      var ctx = c.getContext('2d');
      ctx.drawImage(img, 0, 0);
      var x0 = Math.floor(c.width * 0.25), x1 = Math.ceil(c.width * 0.75);
      var y0 = Math.floor(c.height * 0.25), y1 = Math.ceil(c.height * 0.75);
      var data = ctx.getImageData(x0, y0, x1 - x0, y1 - y0).data;
      var R = [], G = [], B = [], total = 0;
      for (var i = 0; i < data.length; i += 4) {
        total++;
        var r = data[i], g = data[i + 1], b = data[i + 2], a = data[i + 3];
        if (a < 200) continue;
        if (Math.min(r, g, b) > 225) continue;
        if (isSkin(r, g, b)) continue;
        R.push(r); G.push(g); B.push(b);
      }
      if (!total || R.length / total < 0.35 || R.length < 40) return null;
      return [median(R), median(G), median(B)];
    } catch (e) { return null; }
  }
  function paintRgb(el, rgb) {
    el.style.background = 'rgb(' + rgb[0] + ',' + rgb[1] + ',' + rgb[2] + ')';
    el.style.backgroundImage = 'none';
  }
  function paintSolid(el, hex) {
    el.style.background = hex;
    el.style.backgroundImage = 'none';
  }
  function paintDuo(el, a, b) {
    // matches the Liquid gradient: 135deg split at 50%
    el.style.background = 'linear-gradient(135deg,' + a + ' 0 50%,' + b + ' 50% 100%)';
  }

  Array.prototype.forEach.call(swatches, function (el) {
    var val = el.getAttribute('data-value');
    if (!val) return;

    // 0. Manual override wins — solid or two-tone — for any swatch.
    var ov = overrides[val.toLowerCase()];
    if (ov) {
      if (ov.type === 'duo') paintDuo(el, ov.a, ov.b);
      else paintSolid(el, ov.a);
      return;
    }

    // Leave un-overridden two-tone (gradient) dots on their Liquid gradient.
    var style = el.getAttribute('style') || '';
    if (style.indexOf('linear-gradient') !== -1) return;

    // Solid dots: photo-sample with guards.
    var raw = imgForColor(val);
    if (!raw) return;
    var fam = expectedFamily(val);
    load(toUrl(raw)).then(function (img) {
      if (!img) return;
      var rgb = sample(img);
      if (!rgb) return;
      if (fam) {
        var hs = hueSat(rgb[0], rgb[1], rgb[2]);
        if (hs[1] < 0.12 || !inFamily(hs[0], fam)) return;
      }
      paintRgb(el, rgb);
    });
  });
})();
